import { bindActionCreators } from "redux";
import { formValueSelector } from 'redux-form';
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import Form from "../../components/forms/AppealOfficialForm";
import { appealOfficials, withRedirect } from "../../CroActions";
import { decodeBase64 } from "../../CroUtils";
import { breadcrumbs } from "../../../../actions/appActions";

const selector = formValueSelector('appealOfficialForm');

const mapStateToProps = (state, { params, location }) => ({
  breadcrumbsItems: [
    { label: "Funkcionář" },
    { label: "Výzva veřejnému funkcionáři" },
  ],
  initialValues: {
    officialsIds: [params.id],
    noticeTypeId: location.state.noticeTypeId,
  },
  templateKeysHelp: selector(state, "templateKeys"),
  url: `/spravce/api/sablony/notice/${location.state.noticeTypeId}`,
  suppressHttpError: true,
  postProcess: (data) => ({
    ...data,
    content: data && data.content ? decodeBase64(data.content) : ""
  })
});

const onSubmit = (startUrl, dispatch, data) =>
  withRedirect(appealOfficials, `${startUrl}/funkcionari/form/${data.officialsIds[0]}`)(data, dispatch);

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators({ goBack, breadcrumbs }, dispatch),
  onSubmit: (data) => dispatch(onSubmit(props.auth.startUrl, dispatch, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
